import ShellPetrol1 from "../assets/images/clean-img/utts.jpeg";
import ShellPetrol2 from "../assets/images/clean-img/accepting-shell-card.jpeg";
import ShellPetrol3 from "../assets/images/clean-img/shell-club-smart-card-banner.jpeg";
import TtsAbouts from "../assets/images/clean-img/cars-on-road-with-vehicles.jpeg";
import Slider, { type Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TTSForm from "../components/common/TTSForm";
import { products } from "../data/products";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";

export default function Index() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  function CustomNextArrow(props: any) {
    const { className, style, onClick } = props;
    const [hover, setHover] = React.useState(false);
    return (
      <button
        className={className}
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          right: 10,
          zIndex: 2,
          background: hover ? "#ed6c02" : "#fff",
          borderRadius: 0,
          width: 40,
          height: 40,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          color: hover ? "#fff" : "black !important",
          border: hover ? "none" : "2px solid #ed6c02",
          ...(isMobile && {
            display: "none",
          }),
        }}
        onClick={onClick}
        aria-label="Sonraki"
        type="button"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <span style={{ fontSize: 24, color: hover ? "#fff" : "#222" }}>
          {">"}
        </span>
      </button>
    );
  }

  function CustomPrevArrow(props: any) {
    const { className, style, onClick } = props;
    const [hover, setHover] = React.useState(false);
    return (
      <button
        className={className}
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          left: 10,
          zIndex: 2,
          background: hover ? "#ed6c02" : "#fff",
          borderRadius: 0,
          width: 40,
          height: 40,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          border: hover ? "none" : "2px solid #ed6c02",
          ...(isMobile && {
            display: "none"
          })
        }}
        onClick={onClick}
        aria-label="Önceki"
        type="button"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <span style={{ fontSize: 24, color: hover ? "#fff" : "#222" }}>
          {"<"}
        </span>
      </button>
    );
  }

  function CustomDots({ dots }: any) {
    return (
      <ul
        style={{
          display: "flex",
          justifyContent: "center",
          margin: 0,
          padding: 0,
          listStyle: "none",
        }}
      >
        {dots.map((dot: any, idx: number) => (
          <li key={idx} style={{ margin: "0 6px" }}>
            {dot}
          </li>
        ))}
      </ul>
    );
  }

  const settings: Settings = {
    dots: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    //appendDots: (dots) => <CustomDots dots={dots} />,
    customPaging: (i) => (
      <button
        style={{
          width: 12,
          height: 12,
          borderRadius: "50%",
          border: "none",
          padding: 0,
          margin: 0,
          cursor: "pointer",
        }}
        aria-label={`Slide ${i + 1}`}
        type="button"
      />
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const firstSlideSettings: Settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    //appendDots: (dots) => <CustomDots dots={dots} />,
    customPaging: (i) => (
      <button
        style={{
          width: 12,
          height: 12,
          borderRadius: "50%",
          background: "#bbb",
          border: "none",
          padding: 0,
          margin: 0,
          cursor: "pointer",
        }}
        aria-label={`Slide ${i + 1}`}
        type="button"
      />
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const slideItems = [
    {
      img: ShellPetrol1,
      subtitle:
        "Türkiye'nin ilk Taşıt Tanıma Sistemi, Türkiye sınırları içinde firmaların akaryakıt alımları için hızlı, kolay ve güvenli bir filo yönetim sunar.",
    },
    {
      img: ShellPetrol2,
      subtitle:
        "Filo araçları istasyonda vakit kaybetmeden pratik ve hızlı akaryakıt ikmali sağlar.",
    },
    {
      img: ShellPetrol3,
      subtitle:
        "Net ve anlaşılır faturalar ile muhasebe ve idari işlemlerinizin iş yükünü azaltabilirsiniz.",
    },
  ];

  const css = ` .nice-select.wide .list {
    max-height: 300px;
    overflow-y: scroll !important;
}`;

  return (
    <div className="container-fluid-slider animate pageWrapper">
      {/* <!--homeSlider--> */}

      <div className="container-fluid-slider section mainSlide">
        <div className="homeSlider">
          <Slider {...firstSlideSettings}>
            {slideItems.map((value, index) => (
              <div
                key={index}
                className="slide"
                data-mobile={value.img}
                data-desktop={value.img}
              >
                <div className="textcontainer">
                  <div className="container-fluid container">
                    <div className="row middle-lg middle-md middle-sm middle-xs start-lg start-md center-sm center-xs">
                      <div className="col-lg-6 col-md-8 col-sm-10 col-xm-10 col-xs-12">
                        <h2>SHELL TAŞIT TANIMA SİSTEMİ</h2>
                        <span>
                          TÜRKİYE'NİN İLK VE EN BÜYÜK AKARYAKIT YÖNETİM SİSTEMİ{" "}
                        </span>
                        <p>{value.subtitle}</p>
                        <a href="/hemen-basvur" title="Hemen Başvur">
                          HEMEN BAŞVUR
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="cropcontainer"
                  style={{
                    backgroundImage: `url(${value.img})`,
                  }}
                >
                </div>
              </div>
            ))}
          </Slider>
          <div className="slickDots"></div>
        </div>
      </div>

      {/* <!--/homeSlider--> */}

      {/* <!--TTS--> */}
      <div className="container-fluid-slider section first-section">
        <div className="container-fluid-slider container">
          {/* <!--Text--> */}
          <div className="row center-xs">
            <div className="col-lg-12 col-xs textRow">
              <h2 className="title">
                <span className="red">Shell Taşıt Tanıma Sistemi Hakkında</span>
              </h2>
            </div>
          </div>
          {/* <!--/Text--> */}
        </div>
        <div className="container-fluid fullRow mt-3">
          <div className="row ttsAbout start-md center-xs">
            <div
              className="col-lg-6 col-md-6 col-sm-12 col-xm-12 col-xs-12 image"
              style={{
                backgroundImage: `url(${TtsAbouts})`,
              }}
            ></div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xm-12 col-xs-12 text">
              <div className="textCapsule">
                <h3>
                  <small>SHELL TAŞIT TANIMA SİSTEMİ</small>
                  <br />
                  NEDİR?
                </h3>
                <p>
                  Shell Taşıt Tanıma Sistemi, 1996 yılında Türkiye'de öncü
                  olarak Shell tarafından geliştirilen, akaryakıt giderlerinin
                  merkezi yönetimini mümkün kılan dijital tabanlı bir Filo
                  Kontrol Platformudur.
                </p>
                <p>
                  Günümüzde Türkiye çapında Shell ağı ile entegre çalışan 1000+
                  benzin istasyonu aracılığıyla 30.000'den fazla şirketin
                  600.000 aracına kesintisiz hizmet sunmaktadır.
                </p>
                <p>
                  Yakıt deposuna entegre edilen sensörler ve plaka bazlı akıllı
                  erişim sistemleri sayesinde araç tanıma işlemi gerçekleşir.
                  Tüm harcamalar detaylı şekilde kayıt altına alınır ve
                  izlenebilir. Fatura işlemleri aylık periyotlarla otomatik
                  olarak gerçekleştirilir, böylece muhasebe süreçlerinde zaman
                  tasarrufu sağlanır.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--/TTS--> */}

      {/* <!--avantajlar--> */}
      <div className="container-fluid section advantage-section">
        <div className="container-fluid container">
          {/* <!--Text--> */}
          <div className="row center-xs">
            <div className="col-lg-12 col-xs textRow">
              <h2 className="title">
                Shell Taşıt Tanıma Sistemi
                <br />
                <span className="red big">AVANTAJLARI</span>
              </h2>
            </div>
          </div>
          {/* <!--/Text--> */}
          <div className="row mt-1">
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 advantage-box">
              <div className="icon01">
                <h3>Araçtan inmeden akaryakıt ikmali</h3>
                <ul>
                  <li>
                    Türkiye geneline yayılmış 1000'e yakın Shell istasyonu Shell
                    Taşıt Tanıma Sistemi (Shell TTS) ile donatılmıştır.
                  </li>
                  <li>
                    Filo araçları istasyonda vakit kaybetmeden pratik ve hızlı
                    akaryakıt ikmali sağlar.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 advantage-box">
              <div className="icon02">
                <h3>Filoların yakıt yönetiminde kolaylık</h3>
                <ul>
                  <li>
                    Ofisinizden çıkmadan filonuzu rahatça yönetebilirsiniz.
                  </li>
                  <li>
                    Verilerinizi analiz ederek yakıt maliyetinizi kolayca
                    denetleyebilirsiniz.
                  </li>
                  <li>
                    Araç ve filo bazında limit yönetimi ile yakıt tüketimini
                    kontrol altına alabilirsiniz.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 advantage-box">
              <div className="icon03">
                <h3>Muhasebe kolaylığı</h3>
                <ul>
                  <li>
                    Ayda 2 kez kesilen toplu faturalar ile operasyonel kolaylık
                    sağlayabilirsiniz.
                  </li>
                  <li>
                    Net ve anlaşılır faturalar ile muhasebe ve idari
                    işlemlerinizin iş yükünü azaltabilirsiniz.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 advantage-box">
              <div className="icon04">
                <h3>Ödeme kolaylığı</h3>
                <ul>
                  <li>
                    Kredi kartı ödeme yöntemi ile Shell Taşıt Tanıma Sistemi
                    (Shell TTS) kullanarak nakit yönetiminde rahatlık
                    sağlayabilirsiniz.
                  </li>
                  <li>
                    Tüm filonun yakıt alımını tek fatura üzerinden kolayca
                    yönetebilirsiniz.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--/avantajlar--> */}

      {/* <!--nerelerde--> */}
      <div className="container-fluid section">
        <div className="container-fluid container">
          {/* <!--Text--> */}
          <div className="row center-xs">
            <div className="col-lg-12 col-xs textRow">
              <h2 className="title">
                Shell Taşıt Tanıma Sistemi
                <br />
                <span className="red big">NERELERDE KULLANILIR?</span>
              </h2>
              <div className="textCapsule">
                <p>Türkiye Genelinde Yaygın Shell İstasyon Ağı!</p>
              </div>
            </div>
          </div>
          {/* <!--/Text--> */}
          <div className="row mt-2">
            <div className="col-lg col-md col-sm-12 col-xm-12 col-xs-12">
              <div className="where-box">
                <div className="row middle-xs">
                  <div className="col-sm-3 col-xs-4">
                    <p className="icon01">
                      <b>81</b>
                      <br />
                      İl
                    </p>
                  </div>
                  <div className="col-sm-9 col-xs-8">
                    <p>Türkiye Genelinde 81 ili Kapsayan Geniş İstasyon Ağı!</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg col-md col-sm-12 col-xm-12 col-xs-12">
              <div className="where-box">
                <div className="row middle-xs">
                  <div className="col-sm-4 col-xs-4">
                    <p className="icon02">
                      <b>1000+</b>
                      <br />
                      İstasyon
                    </p>
                  </div>
                  <div className="col-sm-8 col-xs-8">
                    <p>
                      Shell Taşıt Tanıma Sistemi (TTS) Üyesi Benzin
                      İstasyonlarından Aracınızdan İnmeden Benzin Alabilirsiniz!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--/nerelerde--> */}
      {/* <!--slogan--> */}
      <div className="container-fluid section slogan01-section">
        <div className="container-fluid container">
          {/* <!--Text--> */}
          <div className="row center-xs">
            <div className="col-lg-10 col-xs">
              <div className="slogan01">
                FİLONUZUN YOLUNDA GİTMESİ İÇİN
                <br />
                HER ZAMAN YANINIZDAYIZ.
              </div>
            </div>
          </div>
          {/* <!--/Text--> */}
        </div>
      </div>
      {/* <!--/slogan--> */}

      {/* <!--ürünler--> */}
      <div className="container-fluid section">
        <div className="container-fluid container">
          {/* <!--Text--> */}
          <div className="row center-xs">
            <div className="col-lg-12 col-xs textRow">
              <h2 className="title">
                <span className="blue">Shell Filo Çözümleri</span>
                <br />
                <span className="red big">ÜRÜNLER</span>
              </h2>
            </div>
          </div>
          {/* <!--/Text--> */}
          <Slider
            className="row mt-3 center-xs productSlideContainer"
            {...settings}
          >
            {products.map((product, index) => (
              <div key={index} className="productSlide">
                <div className={`productBox ${product.subtitle}`}>
                  <span className="ImageIndexSlider">
                    <a
                      href="#"
                      onClick={() =>
                        navigate(product.link, {
                          state: { image: product.img },
                        })
                      }
                      title={product.title}
                    >
                      <img src={product.img} alt={product.title} />
                    </a>
                  </span>
                  <span className="Content">
                    <h3>{product.title}</h3>
                    <span>{product.subtitle}</span>
                    <p>{product.desc}</p>
                    <a
                      href="#"
                      onClick={() => {
                        navigate(product.link, {
                          state: { image: product.img },
                        });
                      }}
                      title="Detaylı Bilgi"
                    >
                      DETAYLI BİLGİ
                    </a>
                  </span>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      {/* <!--/ürünler--> */}

      {/* <!--slogan--> */}
      <div className="container-fluid section slogan02-section">
        <div className="container-fluid container">
          {/* <!--Text--> */}
          <div className="row center-xs">
            <div className="col-lg-10 col-xs">
              <div className="slogan02">
                SHELL TAŞIT TANIM SİSTEMİ İLE
                <br />
                FİLONUZU 7/24 ONLINE YÖNETİN.
              </div>
            </div>
          </div>
          {/* <!--/Text--> */}
        </div>
      </div>
      {/* <!--/slogan--> */}

      <style>
        {css}
        /* Style the input fields */ /* Hide all steps by default: */
      </style>

      {/* <!--talep-formu--> */}
      <div className="container-fluid section">
        <div className="container-fluid container">
          <TTSForm />
        </div>
      </div>
      {/* <!--/talep-formu--> */}
    </div>
  );
}
